"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.vehiclePropType = exports.titleTextPropType = exports.selectionPropType = exports.pricePropType = exports.modelPropType = exports.modelPricePropType = exports.imagePropType = exports.fuelSelectionPropType = exports.disclaimerGroupPropType = exports["default"] = exports.colorPropType = exports.additionalPriceGroupPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = require("@mmc/text");

var pricePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string,
  baseValue: _propTypes["default"].number
});

exports.pricePropType = pricePropType;

var modelPricePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number
});

exports.modelPricePropType = modelPricePropType;

var titleTextPropType = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  text: _propTypes["default"].string
});

exports.titleTextPropType = titleTextPropType;

var vehiclePropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  code: _propTypes["default"].string,
  price: pricePropType,
  name: _propTypes["default"].string,
  selected: _propTypes["default"].bool
});

exports.vehiclePropType = vehiclePropType;

var modelPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  code: _propTypes["default"].string,
  price: modelPricePropType,
  name: _propTypes["default"].string
});

exports.modelPropType = modelPropType;

var imagePropType = _propTypes["default"].shape({
  altText: _propTypes["default"].string,
  image: _propTypes["default"].string
});

exports.imagePropType = imagePropType;

var colorPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  price: pricePropType,
  titleAndText: titleTextPropType,
  selected: _propTypes["default"].bool
});

exports.colorPropType = colorPropType;

var selectionPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  image: imagePropType,
  selected: _propTypes["default"].bool
});

exports.selectionPropType = selectionPropType;

var fuelSelectionPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  selected: _propTypes["default"].bool
});

exports.fuelSelectionPropType = fuelSelectionPropType;

var disclaimerGroupPropType = _propTypes["default"].shape({
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes,
  msrpDisclaimerId: _propTypes["default"].string,
  monthlyMsrpDisclaimerId: _propTypes["default"].string,
  buyMonthlyDisclaimerId: _propTypes["default"].string,
  interestRateDisclaimerId: _propTypes["default"].string,
  leaseMonthlyDisclaimerId: _propTypes["default"].string,
  annualMileageDisclaimerId: _propTypes["default"].string,
  dueAtLeaseSigningDisclaimerId: _propTypes["default"].string,
  destinationFeesDisclaimerId: _propTypes["default"].string
});

exports.disclaimerGroupPropType = disclaimerGroupPropType;

var additionalPriceGroupPropType = _propTypes["default"].shape({
  color: _propTypes["default"].number,
  colorCode: _propTypes["default"].string,
  fabric: _propTypes["default"].number,
  fabricCode: _propTypes["default"].string,
  "package": _propTypes["default"].number,
  packageCodes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  accessory: _propTypes["default"].number,
  accessoryCodes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  destinationFees: _propTypes["default"].number
});

exports.additionalPriceGroupPropType = additionalPriceGroupPropType;

var PROP_TYPES = _propTypes["default"].shape({
  editText: _propTypes["default"].string,
  configurationTitle: _propTypes["default"].string,
  customisationTitle: _propTypes["default"].string,
  includedText: _propTypes["default"].string,
  hideLink: _propTypes["default"].string,
  nextButton: _propTypes["default"].string,
  summaryImage: _propTypes["default"].string,
  id: _propTypes["default"].string,
  toggleImage: _propTypes["default"].string,
  viewSummary: _propTypes["default"].string,
  hideSummary: _propTypes["default"].string,
  selectedVehicleImage: imagePropType,
  vehicle: vehiclePropType,
  model: modelPropType,
  color: colorPropType,
  fabric: colorPropType,
  packages: _propTypes["default"].arrayOf(colorPropType),
  accessories: _propTypes["default"].arrayOf(colorPropType),
  totalPrice: pricePropType,
  driveType: selectionPropType,
  fuelType: fuelSelectionPropType,
  transmissionType: selectionPropType,
  msrpDisclaimerId: _propTypes["default"].string,
  monthlyMsrpDisclaimerId: _propTypes["default"].string,
  buyMonthlyDisclaimerId: _propTypes["default"].string,
  interestRateDisclaimerId: _propTypes["default"].string,
  leaseMonthlyDisclaimerId: _propTypes["default"].string,
  annualMileageDisclaimerId: _propTypes["default"].string,
  dueAtLeaseSigningDisclaimerId: _propTypes["default"].string
});

var _default = PROP_TYPES;
exports["default"] = _default;